import { render, staticRenderFns } from "./Instance.vue?vue&type=template&id=436b5060"
import script from "./Instance.vue?vue&type=script&lang=js"
export * from "./Instance.vue?vue&type=script&lang=js"
import style0 from "./Instance.vue?vue&type=style&index=0&id=436b5060&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports